export const SELECT_LABEL_COLOR = "[SELECT LABEL] SELECT_LABEL_COLOR";
export const RESET_SELECT_LABEL_STATE = "[SELECT LABEL] RESET_SELECT_LABEL_STATE";

export const resetSelectLabelState = () => ({ type: RESET_SELECT_LABEL_STATE });
export const selectLabelColor = color => ({ type: SELECT_LABEL_COLOR, color });